import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";
import useAuth from "../../routes/login/AuthContext";
import { StyledButton } from "./ResidentMenu";
import { UnmatchModal } from "./UnmatchModal";

interface IProps {
  unitId: number;
  onSuccess?: VoidFunction;
  residentId?: string;
}

export const UnmatchButton: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const { isSuperAdminRead } = useAuth();

  const openModal = () => setIsOpen(true);

  return (
    <>
      <StyledButton appearance="subtle" onClick={openModal} isDisabled={isSuperAdminRead()}>
        Unmatch and return to Unplaced
      </StyledButton>
      <UnmatchModal unitId={props.unitId} onSuccess={props.onSuccess} residentId={props.residentId} />
    </>
  );
};
